import { render } from "./SubjectWiseUserCount.vue?vue&type=template&id=2c894678"
import script from "./SubjectWiseUserCount.vue?vue&type=script&lang=js"
export * from "./SubjectWiseUserCount.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__